import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Login from './Login';
import Register from './Register';

function Auth() {
  const [activeView, setActiveView] = useState('login'); // 'login' or 'register'
  const location = useLocation();
  
  useEffect(() => {
    // Log the component mount
    console.log("✅ Auth component mounted", {
      pathname: location.pathname,
      state: location.state,
      search: location.search,
      hash: location.hash
    });
  }, [location]);

  return (
    <div className="auth-container container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          {/* Toggle buttons */}
          <div className="btn-group w-100 mb-4" role="group">
            <button
              type="button"
              className={`btn ${activeView === 'login' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setActiveView('login')}
            >
              Login
            </button>
            <button
              type="button"
              className={`btn ${activeView === 'register' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setActiveView('register')}
            >
              Register
            </button>
          </div>
          
          {/* Render either Login or Register component based on activeView */}
          {activeView === 'login' ? <Login /> : <Register />}
        </div>
      </div>
    </div>
  );
}

export default Auth; 